import React from 'react'
import { Typography } from 'antd'
import AccountSettings from '@/components/AccountSettings'

const { Title, Text } = Typography

const Settings: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <Title level={2}>账号安全</Title>
        <Text type="secondary">管理登录方式、密码和活跃会话</Text>
      </div>
      <AccountSettings />
    </div>
  )
}

export default Settings
